import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgChatAlt = function SvgChatAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M19.953.75H4.046A3.981 3.981 0 00.062 4.734v9.985a3.981 3.981 0 003.984 3.984H14l4.266 4.266c.188.187.469.281.703.281.516 0 .985-.375.985-.984v-3.61a3.981 3.981 0 003.984-3.984V4.734C23.984 2.531 22.156.75 19.953.75zm2.062 13.922c0 1.078-.937 2.015-2.062 2.015h-2.016v3.141l-2.531-2.578-.563-.563H4.046c-1.078 0-2.015-.89-2.015-2.015V4.734c0-1.078.89-2.015 2.015-2.015H20c1.078 0 2.015.89 2.015 2.015v9.938z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M6.046 11.719a2.016 2.016 0 100-4.032 2.016 2.016 0 000 4.032zM12 11.719a2.016 2.016 0 100-4.032 2.016 2.016 0 000 4.032zM18 11.719a2.016 2.016 0 100-4.032 2.016 2.016 0 000 4.032z"
  }));
};

export default SvgChatAlt;